import { canUseDOM } from '@ps/web-core-utils';

export const initModuleNativeClient = (module: string) => {
  if (
    canUseDOM &&
    !window.starsweb?.[module as keyof typeof window.starsweb] &&
    window.starsweb?.module
  ) {
    window.starsweb.module(module);
  }
};
